import { Link } from 'react-router-dom';

import SocialSpectrumSvg from '../../assets/social.svg';

type PropTypes = {
	width: string;
	height: string;
};
export default function Logo({ width, height }: PropTypes) {
	return (
		<Link to="/">
			<img
				src={SocialSpectrumSvg}
				width={width}
				height={height}
				alt="Social Spectrum Logo"
				className='py-2'
			/>
		</Link>
	);
}
